import axios from 'axios';

const state = {
    exists: true,
    timeZoneId: false,
    open: false,
};

const getters = {
  timeModal: state => state,
};

const actions = {
  coregroupCheck: ({ commit }, coreGroupId) => {
      return new Promise((resolve, reject) => {
          axios.get('/api/coregroup/check/' + coreGroupId)
              .then(response => {
                  commit("setTimeModal", response.data.exists);
                  commit("setTimeZone", response.data.timeZoneId);
                  resolve(response);
                  if(response.data.exists === false){
                    commit("showTimeModal", true);
                  } else {
                    commit("showTimeModal", false);
                  }
              })
              .catch(error => {
                  console.error(error);
                  reject(error);
              });
      });
  }
};

const mutations = {
  setTimeModal: (state, value) => (state.exists = value),
  setTimeZone: (state, value) => (state.timeZoneId = value),
  showTimeModal: (state, value) => (state.open = value)
};

export default {
  state,
  getters,
  actions,
  mutations
};
